import React, { useState, useEffect } from 'react';
import './LegalDisclaimerModal.css';



const ShieldIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);


const LegalDisclaimerModal = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const hasAccepted = sessionStorage.getItem('disclaimerAccepted');
    if (!hasAccepted) {
      const timer = setTimeout(() => setShowModal(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (showModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [showModal]);

  const handleAccept = () => {
    sessionStorage.setItem('disclaimerAccepted', 'true');
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="disclaimer-modal-overlay">
      <div
        className="disclaimer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="disclaimer-title"
      >
        <div className="disclaimer-modal-header">
          <ShieldIcon />
          <h2 id="disclaimer-title">Legal Disclaimer</h2>
          <p>Please acknowledge the following terms to proceed.</p>
        </div>

        <div className="disclaimer-modal-content">
          <div className="disclaimer-text-block">
            <p>
              In compliance with the rules and professional standards prescribed by the Bar Council of India,
              this website of EdZure Legal LLP (the “Firm”) is intended solely to provide general information
              regarding the Firm, its practice areas, advocates, and professional activities. The material
              contained on this website is not intended for the purpose of advertising, soliciting work,
              or creating any form of inducement for professional engagement by the Firm or any of its members,
              nor shall it be construed as legal advice or legal opinion in any manner whatsoever.
            </p>
            <p>
              All content available on this website, including text, design, and materials, constitutes
              the intellectual property of EdZure Legal LLP and is protected under applicable laws.
              By accessing this website, the visitor acknowledges that the information provided herein
              is solely for the purpose of understanding the Firm and its professional activities
              and that accessing this website does not create a lawyer–client relationship.
              Visitors are advised to seek independent professional legal advice before acting upon
              any information contained on this website.
            </p>
          </div>
        </div>

        <div className="disclaimer-modal-footer">
          <button
            className="btn-accept"
            onClick={handleAccept}
          >
            Accept and Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalDisclaimerModal;
